<!--title -->
<app-modal-title
  [title]="formPageConfig.title | translate"
  [isShowClose]="true"
  (isCloseModal)="onClose()"
></app-modal-title>

<div mat-dialog-content class="dialog-content">
  <!-- form -->
  <form [formGroup]="form" autocomplete="off">
    <div class="tw-flex-center flex-column">
      <!-- category name -->
      <div class="tw-w-[300px]">
        <form-field
          [(value)]="model.categoryName"
          [control]="form?.get('categoryName')"
          [label]="isUserForGroupPriceCopy ? 'common.newName' : 'common.title'"
        >
        </form-field>
      </div>
    </div>

    <!-- submit btn -->
    <app-form-btns
      [loading]="loading"
      [form]="form"
      [isEdit]="formPageConfig.isEditMode"
      (onClose)="onClose()"
      (onSubmit)="onSubmit()"
    >
    </app-form-btns>
  </form>
</div>
